import { render, staticRenderFns } from "./rating-dialog.vue?vue&type=template&id=08b3df0a&scoped=true"
import script from "./rating-dialog.vue?vue&type=script&lang=js"
export * from "./rating-dialog.vue?vue&type=script&lang=js"
import style0 from "./rating-dialog.vue?vue&type=style&index=0&id=08b3df0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3df0a",
  null
  
)

export default component.exports